import React from 'react';

export default function Footer() {
  return (
    <footer className="text-center py-3 mt-4 border-top" style={{ fontSize: '.78rem', color: '#94a3b8' }}>
      © {new Date().getFullYear()}{' '}
      <span style={{ fontFamily: 'Plus Jakarta Sans,sans-serif', fontWeight: 700 }}>
        <span style={{ color: '#0ea5e9' }}>Termo</span>Track
      </span>
      {' '}— Soğuk Zincir Takip Sistemi
    </footer>
  );
}
